"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PlayerState_1 = __importDefault(require("../../constants/PlayerState"));

var createRxPlayerLoadOptions_1 = __importDefault(require("../../utils/createRxPlayerLoadOptions"));

var isSamsungBrowser = function isSamsungBrowser(nav) {
  return nav.userAgent.indexOf('SamsungBrowser') !== -1;
};

var RxPlayerController =
/** @class */
function () {
  function RxPlayerController(rxPlayer) {
    this.listeners = new Map();
    this.rxPlayer = rxPlayer;
    this.isDirectfile = false;
    this.nativeControls = false;
  }

  RxPlayerController.prototype.addEventListener = function (eventName, callback) {
    var _this = this; // Add to this.listeners


    var arr = this.listeners.get(eventName);

    if (arr) {
      arr.push(callback);
    } else {
      this.listeners.set(eventName, [callback]);
    } // Work-around for SamsungBrowser bug


    if (isSamsungBrowser(navigator) && eventName === 'playerStateChange') {
      return this.rxPlayer.addEventListener(eventName, function (ev) {
        if (ev === PlayerState_1["default"].ENDED && _this.rxPlayer.getPosition() === 0) {
          // Skip bad ENDED state
          return;
        }

        callback(ev);
      });
    }

    return this.rxPlayer.addEventListener(eventName, callback);
  };

  RxPlayerController.prototype.removeEventListener = function (eventName, callback) {
    // Remove from this.listeners
    var arr = this.listeners.get(eventName);

    if (arr) {
      if (callback) {
        var index = arr.indexOf(callback);

        if (index !== -1) {
          arr.splice(index, 1);
        }
      } else {
        this.listeners["delete"](eventName);
      }
    }

    return this.rxPlayer.removeEventListener(eventName, callback);
  };

  RxPlayerController.prototype.dispatchEvent = function (eventName, payload) {
    var arr = this.listeners.get(eventName);

    if (arr) {
      arr.forEach(function (callback) {
        return callback(payload);
      });
    }
  };

  RxPlayerController.prototype.dispose = function () {
    this.listeners = new Map();
    return this.rxPlayer.dispose();
  };

  RxPlayerController.prototype.getUrl = function () {
    return this.rxPlayer.getUrl();
  };

  RxPlayerController.prototype.getVolume = function () {
    return this.rxPlayer.getVolume();
  };

  RxPlayerController.prototype.getVideoElement = function () {
    return this.rxPlayer.getVideoElement();
  };

  RxPlayerController.prototype.isMute = function () {
    var videoElement = this.getVideoElement();
    var videoElementMuted = Boolean(videoElement && videoElement.muted);
    return this.rxPlayer.isMute() || videoElementMuted;
  };

  RxPlayerController.prototype.loadVideo = function (streamInfo, options) {
    var loadOptions = createRxPlayerLoadOptions_1["default"](streamInfo, options || {});
    this.rxPlayer.loadVideo(loadOptions);
    this.isDirectfile = loadOptions && loadOptions.transport === 'directfile';
    var videoElement = this.getVideoElement();

    if (videoElement) {
      var autoPlay = Boolean(options && options.autoPlay);

      if (isSamsungBrowser(navigator)) {
        videoElement.preload = autoPlay ? 'auto' : 'none';
      }

      videoElement.autoplay = autoPlay;
    }
  };

  RxPlayerController.prototype.mute = function () {
    // rx-player never change the muted attribute on the video element.
    // We change it because it is used by browers for auto play policy.
    var videoElement = this.getVideoElement();

    if (videoElement && !videoElement.muted) {
      videoElement.muted = true; // rx-player will not trigger volumeChange if the volume is already
      // set to 0, because the volume value does not change. But since
      // the muted value is changed we must manually trigger volumeChange.

      if (this.getVolume() === 0) {
        this.dispatchEvent('volumeChange', 0);
      }
    }

    return this.rxPlayer.mute();
  };

  RxPlayerController.prototype.unMute = function () {
    // rx-player never change the muted attribute on the video element.
    // We change it because it is used by browers for auto play policy.
    var videoElement = this.getVideoElement();

    if (videoElement && videoElement.muted) {
      videoElement.muted = false; // rx-player will not trigger volumeChange if the volume is already
      // set to 1, because the volume value does not change. But since
      // the muted value is changed we must manually trigger volumeChange.

      if (this.getVolume() === 1) {
        this.dispatchEvent('volumeChange', 1);
      }
    }

    return this.rxPlayer.unMute();
  };

  RxPlayerController.prototype.getMaximumPosition = function () {
    if (this.isDirectfile) {
      var videoElement = this.getVideoElement();
      return videoElement && videoElement.seekable.length > 0 ? videoElement.seekable.end(0) : 0;
    }

    return this.rxPlayer.getMaximumPosition();
  };

  RxPlayerController.prototype.seekTo = function (time) {
    var maxTime = this.rxPlayer.getMaximumPosition();
    var minTime = this.rxPlayer.getMinimumPosition();

    if (maxTime !== null) {
      time = Math.min(time, maxTime);
    }

    if (minTime !== null) {
      time = Math.max(time, minTime);
    }

    return this.rxPlayer.seekTo(time);
  };

  RxPlayerController.prototype.setMaxVideoBitrate = function (bitrate) {
    return this.rxPlayer.setMaxVideoBitrate(bitrate);
  };

  RxPlayerController.prototype.setVolume = function (volume) {
    if (volume > 0) {
      this.unMute();
    }

    return this.rxPlayer.setVolume(volume);
  };

  RxPlayerController.prototype.stop = function () {
    return this.rxPlayer.stop();
  };

  RxPlayerController.prototype.pause = function () {
    return this.rxPlayer.pause();
  };

  RxPlayerController.prototype.play = function () {
    return this.rxPlayer.play();
  };

  RxPlayerController.prototype.useNativeControls = function (enabled) {
    this.nativeControls = enabled;
  };

  RxPlayerController.prototype.hasNativeControls = function () {
    return this.nativeControls;
  };

  return RxPlayerController;
}();

exports["default"] = RxPlayerController;